import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
	// load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
	// learn more: https://github.com/i18next/i18next-http-backend
	// want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
	.use(Backend)
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	.use(initReactI18next) // bind react-i18next to the instance
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		fallbackLng: "en",
		debug: true,
		load: "languageOnly", // load only language code, not region (e.g. 'en' instead of 'en-US')
		interpolation: {
			escapeValue: false // not needed for react!!
		},

		// react i18next special options (optional)
		// override if needed - omit if ok with defaults
		react: {
			// bindI18n: "languageChanged",
			// bindI18nStore: "",
			// transEmptyNodeValue: "",
			transSupportBasicHtmlNodes: true,
			transKeepBasicHtmlNodesFor: ["br", "strong", "i"]
			// useSuspense: true
		}
	});

export default i18n;
